/**
 * WebRTC API Detector
 */

export interface WebRTCResult {
  supported: boolean;
  devices: number;
}

export async function detectWebRTC(): Promise<WebRTCResult> {
  try {
    const RTCPeerConnection =
      (window as Window & { RTCPeerConnection?: unknown }).RTCPeerConnection ||
      (window as Window & { webkitRTCPeerConnection?: unknown }).webkitRTCPeerConnection;

    if (!RTCPeerConnection) {
      return { supported: false, devices: 0 };
    }

    // Try to enumerate devices
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return {
        supported: true,
        devices: devices.length,
      };
    }

    return { supported: true, devices: 0 };
  } catch (error) {
    return { supported: false, devices: 0 };
  }
}
